import { UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client';

let baseIdentityURLBase = '';
switch (window.location.hostname) {
  case 'localhost':
  case 'queue-dev.griddeveloper.com':
    baseIdentityURLBase = 'https://id.griddeveloper.com/';
    break;
  case 'queue-qa.omborigrid.com':
  case 'queue.qa.omborigrid.com':
    baseIdentityURLBase = 'https://id-qa.ombori.com/';
    break;
  case 'queue-in.omborigrid.com':
  case 'queue-eu.omborigrid.com':
  case 'queue-au.omborigrid.com':
  case 'queue-uae.omborigrid.com':
  case 'queue-us.omborigrid.com':
  case 'queue.in.ombori.com':
  case 'queue.eu.ombori.com':
  case 'queue.au.ombori.com':
  case 'queue.uae.ombori.com':
  case 'queue.us.ombori.com':
  case 'booking.ikea.com.bh':
  case 'booking.ikea.com.sa':
  default:
    baseIdentityURLBase = 'https://id.ombori.com/';
    break;
}

export const baseIdentityURL = baseIdentityURLBase;

export function getClientSettings(): UserManagerSettings {
  const { origin } = window.location;
  return {
    authority: baseIdentityURL,
    client_id: 'queue-app',
    redirect_uri: `${origin}/auth-callback`,
    post_logout_redirect_uri: `${origin}/logout-callback`,
    response_type: 'code',
    scope: 'openid email',
    filterProtocolClaims: true,
    stateStore: new WebStorageStateStore({ prefix: 'oidc', store: localStorage }),
    userStore: new WebStorageStateStore({ prefix: 'oidc', store: localStorage }),
  };
}

const manager = new UserManager(getClientSettings());

export default manager;
